// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SZKDp","footer":"styles_footer__Q6aBu","passCodeTooltip":"styles_passCodeTooltip__1tADK"};